<template>
  <div class="settings-form glass animate__animated animate__fadeIn">
    <h2 class="title is-4 has-text-primary mb-5">
      <b-icon icon="cog" class="mr-2"></b-icon>Configuración del Evento
    </h2>

    <div class="columns is-multiline">
      <!-- Imagen de Propaganda -->
      <div class="column is-12">
        <b-field label="Imagen de Propaganda (Popup /inicio)">
          <div class="image-upload-box propaganda">
            <img v-if="urlPropaganda" :src="urlPropaganda" class="preview-img">
            <div v-else class="no-image-placeholder">
               <b-icon icon="image-off-outline" size="is-large"></b-icon>
               <p>Sin imagen configurada</p>
            </div>
            <div class="upload-controls buttons is-centered are-small">
              <b-upload v-model="filePropaganda" @input="onPropagandaChange" type="is-primary" class="mr-2">
                <a class="button is-primary is-light">
                  <b-icon icon="upload" size="is-small"></b-icon>
                  <span>{{ urlPropaganda ? 'Cambiar' : 'Subir Imagen' }}</span>
                </a>
              </b-upload>
              <b-button 
                v-if="urlPropaganda" 
                type="is-danger" 
                icon-left="delete" 
                outlined
                @click="eliminarPropaganda"
              >
                Quitar
              </b-button>
            </div>
          </div>
        </b-field>
      </div>

      <!-- Términos y Condiciones -->
      <div class="column is-12 mt-4">
        <b-field label="Términos y Condiciones (Reglas del Evento)">
          <b-input 
            type="textarea" 
            v-model="datosNegocio.terminos" 
            placeholder="Escribe aquí las reglas, términos y condiciones que aparecerán en el botón de reglas."
            rows="8"
          ></b-input>
        </b-field>
      </div>
    </div>

    <div class="buttons is-centered mt-6">
      <b-button 
        type="is-primary" 
        size="is-large" 
        icon-left="check-bold" 
        @click="registrar"
        class="main-save-btn"
      >Guardar Cambios</b-button>
      <b-button 
        type="is-text" 
        tag="router-link" 
        to="/dashboard"
      >Volver al Dashboard</b-button>
    </div>
  </div>
</template>

<script>
import Utiles from '../../Servicios/Utiles'

export default {
  name: "FormConfiguracion",
  props: ["datos"],

  data: () => ({
    datosNegocio: {
      imagen_propaganda: "",
      terminos: ""
    },
    urlPropaganda: null,
    filePropaganda: null,
  }),

  mounted() {
    // Spread all existing data (keeps backend fields intact even if not shown)
    this.datosNegocio = { ...this.datos };
    const apiBase = Utiles.regresarRuta().split('api')[0];
    
    this.urlPropaganda = this.datos.imagen_propaganda ? apiBase + this.datos.imagen_propaganda : null;

    document.title = 'Configuraciones';
  },

  methods: {
    onPropagandaChange(file) {
      if (file) {
        const reader = new FileReader();
        reader.onload = e => {
          this.urlPropaganda = e.target.result;
          this.datosNegocio.imagen_propaganda = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    registrar() {
      this.$emit("registrar", this.datosNegocio);
    },
    eliminarPropaganda() {
      this.datosNegocio.imagen_propaganda = "";
      this.urlPropaganda = null;
      this.filePropaganda = null;
    }
  }
}
</script>

<style scoped>
.settings-form {
  max-width: 700px;
  margin: 20px auto;
  padding: 40px;
  border-radius: 24px;
}

.glass {
  background: rgba(30, 41, 59, 0.85);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #e2e8f0;
}

.image-upload-box {
  border: 2px dashed rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 30px;
  text-align: center;
  position: relative;
  background: rgba(15, 23, 42, 0.5);
  min-height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.preview-img {
  max-height: 180px;
  border-radius: 8px;
  margin-bottom: 15px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
}

.no-image-placeholder {
  color: #64748b;
  margin-bottom: 15px;
}

.upload-controls {
  margin-top: 10px;
}

.main-save-btn {
  padding-left: 50px;
  padding-right: 50px;
  font-weight: 700;
  box-shadow: 0 10px 20px rgba(50, 115, 220, 0.2);
}

.animate__animated {
  animation-duration: 0.6s;
}
</style>
